import { produce } from 'immer'
import { create } from 'zustand'
import CONSTANTS from '../../../../constants'

type NewConnAllEnrollmentFormState = {
	isFormValid: boolean
	formValues: Record<string, any>
}

type NewConnAllEnrollmentFormActions = {
	actions: {
		clearFormValues: () => void
		setFormValues: (fieldName: string, value: any) => void
		setFormValidity: (isValid: boolean) => void
	}
}

const initialFormValues = {
	viewerEmails: [],
	analysisFrequency: CONSTANTS.CA_ANALYSIS_FREQUENCY_OPTIONS[0].value
}

const newConnAllEnrollmentFormStore = create<
	NewConnAllEnrollmentFormState & NewConnAllEnrollmentFormActions
>((set, _get) => ({
	isFormValid: false,
	formValues: initialFormValues,
	actions: {
		clearFormValues: () => set(() => ({ formValues: initialFormValues })),
		setFormValidity: (isValid: boolean) =>
			set(() => ({ isFormValid: isValid })),
		setFormValues: (fieldName: string, value: any) =>
			set((state) =>
				produce(state, (draft) => {
					draft.formValues[fieldName] = value

					if (fieldName === 'analysisFrequency') {
						draft.formValues[fieldName] =
							value.value !== 'none' ? value.value : null
					}
				})
			)
	}
}))

export const useNewConnAllEnrollmentFormStore = () =>
	newConnAllEnrollmentFormStore((state) => state)
